module.exports = __webpack_public_path__ + "static/media/portraitA.bcb3cd3f.jpg";